import React from 'react'
import { PageHeader, PageContent } from 'SRC/ui'
import { getProfileLoading } from '../../../selectors'
import { connect } from 'react-redux'
import withTranslation from 'next-translate/withTranslation'
import { compose } from 'recompose'
import PropTypes from 'prop-types'
import { adsListViews } from 'Core/constants'
import { Preloader } from 'SRC/ui/Preloader'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { fetchFavouriteAds } from '../../../actions'
import { 
  getFavouriteExpiredAds,
  getFavouritePublishedAds,
  getFavouriteSoldAds
} from '../../../selectors/getFavouriteAds'
import { 
  getFavouritePublishedAdsLoading,
  getFavouriteExpiredAdsLoading,
  getFavouriteSoldAdsLoading
} from '../../../selectors/getFavouriteAdsLoading'
import { CardViewList } from '../../../../../ads/list/components/CardView'
import { GridViewList } from '../../../../../ads/list/components/GridView'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'

export class SavedAds extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      style: adsListViews.TABLE,
      status: 'Published'
    }

    this.tableRef = React.createRef()
    this.listRef = React.createRef()
  }

  componentDidUpdate = (prevProps, prevState) => {
    // Get ads if status updated
    if(prevState.status !== this.state.status) {
      const cookie = new CookiesHelper()
      const userId = cookie.get('userId')
      const token = cookie.get('token')
      if(userId && token) {
        this.props.fetchFavouriteAds(userId, token, this.state.status, 1, 100)
      }
    }
  }

  setPublished = () => this.setState({...this.state, status: 'Published'})
  setExpired = () => this.setState({...this.state, status: 'Expired'})
  setSold = () => this.setState({...this.state, status: 'Sold'})

  setTableView = () => this.setState({...this.state, style: adsListViews.TABLE})

  setListView = () => this.setState({...this.state, style: adsListViews.LIST})

  render () {
    const { isMobileDevice, i18n: { t } } = this.props
    let ads = []
    let isAdsLoading = false

    switch(this.state.status) {
      case 'Published':
        ads = this.props.publishedSavedAds
        isAdsLoading = this.props.isPublishedSavedAdsLoading
        break;
      case 'Expired':
        ads = this.props.expiredSavedAds
        isAdsLoading = this.props.isExpiredSavedAdsLoading
        break;
      case 'Sold':
        ads = this.props.soldSavedAds
        isAdsLoading = this.props.isSoldSavedAdsLoading
        break;
      default: break;
    }

    return [
      <PageHeader key='header'>{t(`common:Sačuvani oglasi`)}</PageHeader>,
      <div className='oglasi' key='oglasi'>
        <div className='oglasi-filter sacuvani-oglasi-filter clearfix'>
          <div className='oglasi-filter-content'>
            <ul>
              <li className={this.state.status === 'Published' ? 'active' : ''}>
                <a href='#' onClick={this.setPublished}>
                <i className='ico-ima ico' />
                  {t(`common:Aktivno`)} [{this.props.publishedSavedAds.length}]
                </a>
              </li>
              <li className={this.state.status === 'Expired' ? 'active' : ''}>
                <a href='#' onClick={this.setExpired}>
                <i className='ico-istekao-oglas ico' /> 
                  {t(`common:Isteklo`)} [{this.props.expiredSavedAds.length}]
                </a>
              </li>
              <li className={this.state.status === 'Sold' ? 'active' : ''}>
                <a href='#' onClick={this.setSold}>
                <i className='ico-prodat-oglas ico' />
                  {t(`common:Prodato`)} [{this.props.soldSavedAds.length}]
                </a>
              </li>
            </ul>
          </div>
          {!isMobileDevice ? (
            <div className='oglasi-filter-grid'>
              <ul>
                <li className={this.state.style === adsListViews.TABLE ? 'active' : ''}>
                  <a href='#' onClick={this.setTableView}>
                    <i className='ico-filter-prikaz-lista-ikonice ico' />
                  </a>
                  <div className='tooltip'>{t(`common:Tabelarni prikaz`)}</div>
                </li>
                <li className={this.state.style === adsListViews.LIST ? 'active' : ''}>
                  <a href='#' onClick={this.setListView}>
                    <i className='ico-filter-prikaz-grid-tekst ico' />
                  </a>
                  <div className='tooltip'>{t(`common:Slikovni prikaz`)}</div>
                </li>
              </ul>
            </div>
          ) : null}
        </div>
        
        {!isAdsLoading ? 
          <div className='sacuvani-oglasi-content'>
            <GridViewList
              ads={ads}
              style={this.state.style}
              ref={this.tableRef}
              // noAdsMessage={`Trenutno nema sačuvanih oglasa`}
              noAdsMessage={t('common:no_saved_ads_text')}
            />
            <CardViewList
              ads={ads}
              style={this.state.style}
              ref={this.listRef}
              noAdsMessage={t('common:no_saved_ads_text')}
            />
            {
              this.props.isLoading && !this.props.isAppLoading ? <Preloader /> : null
            }
          </div>  : <Preloader />}
        
        {this.props.isLoading ? <Preloader /> : null}
      </div>
    ]
  }
}

const mapStateToProps = state => ({
  isLoading: getProfileLoading(state),
  publishedSavedAds: getFavouritePublishedAds(state),
  expiredSavedAds: getFavouriteExpiredAds(state),
  soldSavedAds: getFavouriteSoldAds(state),
  isPublishedSavedAdsLoading: getFavouritePublishedAdsLoading(state),
  isExpiredSavedAdsLoading: getFavouriteExpiredAdsLoading(state),
  isSoldSavedAdsLoading: getFavouriteSoldAdsLoading(state),
  isMobileDevice: getIsMobileDevice(state)
})

SavedAds.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  publishedSavedAds: PropTypes.array.isRequired,
  expiredSavedAds: PropTypes.array.isRequired,
  soldSavedAds: PropTypes.array.isRequired,
  isPublishedSavedAdsLoading: PropTypes.bool.isRequired,
  isExpiredSavedAdsLoading: PropTypes.bool.isRequired,
  isSoldSavedAdsLoading: PropTypes.bool.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  fetchFavouriteAds: PropTypes.func.isRequired
}

SavedAds.defaultProps = {
  isLoading: false
}

const enhance = compose(
  withTranslation,
  connect(mapStateToProps, { fetchFavouriteAds })
)

export default enhance(SavedAds)
